var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneMobile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-18.000000, -839.000000) translate(0.000000, 573.000000) translate(18.000000, 56.000000) translate(1.000000, 98.000000) translate(0.000000, 113.000000)",
    stroke: "#000",
    strokeWidth: 1.05,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7693997,17.1889066 L18.7065068,15.2849207 C17.9139039,14.5526927 16.6774239,14.6024417 15.945196,15.3950447 L15.943747,15.3964937 C14.674423,16.7720776 12.5299031,16.8570856 11.1548022,15.5882447 L7.49221334,12.2067618 C6.1166294,10.9369549 6.0311384,8.792435 7.30046235,7.41733406 L7.30191135,7.41588506 C8.03462231,6.6227991 7.98487332,5.38631916 7.19227035,4.65409119 L5.12937744,2.74962228 C4.32711448,2.00918331 3.07614454,2.05941531 2.33570557,2.86167827 L1.6479136,3.60646424 C-0.679663291,6.12772412 -0.522688299,10.0583779 1.99905459,12.3864378 L2.37579457,12.7341978 L2.38497157,12.7424088 L11.0277732,20.7215685 L11.0383992,20.7317115 L11.4136902,21.0780224 C13.93495,23.4055993 17.8656039,23.2486243 20.1936638,20.7273645 L20.8809727,19.9825785 C21.6218947,19.1803155 21.5716627,17.9293456 20.7693997,17.1889066 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4489523,5.23180746 C12.6498803,5.20475946 12.8551553,5.19075246 13.0633283,5.19075246 C15.5628532,5.19075246 17.5972491,7.18361037 17.6639031,9.66719626",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1380935,2.63896698 C12.4757105,2.58873498 12.8215385,2.56313598 13.1736455,2.56313598 C16.9864473,2.56313598 20.0873072,5.61424685 20.1665192,9.40869467 C20.1674852,9.45844367 20.1684512,9.50819267 20.1684512,9.55794167",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5343436,0.118817995 C12.0327995,0.0405719982 12.5433305,7.99360578e-15 13.0635215,7.99360578e-15 C18.4224062,7.99360578e-15 22.775202,4.3035298 22.85538,9.64357756",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneMobile);
export default __webpack_public_path__ + "static/media/phone-mobile.a2d4b548018414d204746a21311f4511.svg";
export { ForwardRef as ReactComponent };